import "./instrument"; // Sentry must init before any other imports
import { Buffer } from "buffer";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { supabase } from "@/integrations/supabase/client";
import { installEdgeFunctionErrorMessages } from "@/lib/installEdgeFunctionErrorMessages";

// Specific messages for every edge-function failure instead of the SDK's generic
// "non-2xx status code" text. Installed before any component can call invoke.
installEdgeFunctionErrorMessages(supabase);

if (typeof window !== "undefined" && !("Buffer" in window)) {
  (window as Window & { Buffer?: typeof Buffer }).Buffer = Buffer;
}

createRoot(document.getElementById("root")!).render(<App />);
